<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <path
            d="M12.0013 2.60156C12.4984 2.60156 12.9013 3.00451 12.9013 3.50156V12.8293L15.8649 9.86565C16.2164 9.51418 16.7862 9.51418 17.1377 9.86565C17.4892 10.2171 17.4892 10.787 17.1377 11.1384L12.6377 15.6384C12.2862 15.9899 11.7164 15.9899 11.3649 15.6384L6.86493 11.1384C6.51346 10.787 6.51346 10.2171 6.86493 9.86565C7.21641 9.51418 7.78625 9.51418 8.13772 9.86565L11.1013 12.8293V3.50156C11.1013 3.00451 11.5043 2.60156 12.0013 2.60156Z"
            fill="currentColor"
        />
        <path
            d="M21.1515 14.9016C21.1515 14.4046 20.7486 14.0017 20.2515 14.0017C19.7545 14.0017 19.3515 14.4046 19.3515 14.9016V17.4518C19.3515 18.2663 19.3404 18.4601 19.2977 18.5917C19.1889 18.9266 18.9263 19.1891 18.5915 19.2979C18.4599 19.3406 18.2661 19.3518 17.4515 19.3518H6.55158C5.73702 19.3518 5.54318 19.3406 5.41166 19.2979C5.07678 19.1891 4.81423 18.9266 4.70542 18.5917C4.66269 18.4601 4.65158 18.2663 4.65158 17.4518V14.9017C4.65158 14.4046 4.24863 14.0017 3.75157 14.0017C3.25451 14.0017 2.85156 14.4046 2.85156 14.9017V17.0872C2.85155 17.617 2.85154 18.0683 2.8818 18.4386C2.9136 18.8278 2.98323 19.2064 3.16765 19.5683C3.44568 20.114 3.88932 20.5576 4.43499 20.8357C4.79692 21.0201 5.17551 21.0897 5.56467 21.1215C5.93509 21.1518 6.38624 21.1518 6.91608 21.1518H17.0869C17.6168 21.1518 18.068 21.1518 18.4384 21.1215C18.8276 21.0897 19.2062 21.0201 19.5681 20.8357C20.1138 20.5576 20.5574 20.114 20.8354 19.5683C21.0198 19.2064 21.0895 18.8278 21.1213 18.4386C21.1515 18.0682 21.1515 17.6171 21.1515 17.0872V14.9016Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: 'download-icon',
    props: {
        width: {
            type: [String, Number],
            default: 24,
        },
        height: {
            type: [String, Number],
            default: 24,
        },
        color: {
            type: String,
            default: 'text-blue-600', 
        },
    },
};
</script>
